import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { CheckCircleIcon } from 'lucide-react';
const AlumniJoin = () => {
  const [formStep, setFormStep] = useState(1);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, this would submit the form data to a server
    setFormSubmitted(true);
  };
  const nextStep = () => {
    setFormStep(formStep + 1);
  };
  const prevStep = () => {
    setFormStep(formStep - 1);
  };
  return <div className="min-h-screen bg-white" data-id="element-3304">
      <PageHeader title="Join the Alumni Association" description="Connect with fellow alumni, stay updated with school news, and contribute to the growth of your alma mater." backgroundImage="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Alumni',
      path: '/alumni'
    }, {
      label: 'Join',
      path: '/alumni/join'
    }]} data-id="element-3305" />
      <div className="container mx-auto px-4 py-12" data-id="element-3306">
        <div className="text-center mb-10" data-id="element-3307">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3308">
            Alumni Association Membership
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3309"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3310">
            Join a network of over 15,000 IGS alumni worldwide. Membership in
            the Alumni Association provides numerous benefits and opportunities
            to give back to your alma mater.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-3311">
          <div className="lg:col-span-2 bg-white p-6 rounded-lg shadow-md" data-id="element-3312">
            {formSubmitted ? <div className="text-center py-12" data-id="element-3313">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6" data-id="element-3314">
                  <CheckCircleIcon className="h-10 w-10 text-green-600" data-id="element-3315" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-3316">
                  Registration Successful!
                </h3>
                <p className="text-gray-700 mb-6 max-w-lg mx-auto" data-id="element-3317">
                  Thank you for joining the Isonyin Grammar School Alumni
                  Association. Your application has been received and is being
                  processed.
                </p>
                <p className="text-gray-700 mb-8 max-w-lg mx-auto" data-id="element-3318">
                  You will receive a confirmation email shortly with further
                  instructions on how to complete your membership process.
                </p>
                <Button href="/alumni" variant="primary" data-id="element-3319">
                  Return to Alumni Page
                </Button>
              </div> : <>
                <div className="mb-8" data-id="element-3320">
                  <div className="flex items-center justify-between mb-4" data-id="element-3321">
                    <div className="flex items-center" data-id="element-3322">
                      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${formStep >= 1 ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-500'} mr-2`} data-id="element-3323">
                        1
                      </div>
                      <span className={`font-medium ${formStep >= 1 ? 'text-blue-900' : 'text-gray-500'}`} data-id="element-3324">
                        Personal Information
                      </span>
                    </div>
                    <div className="flex-1 h-1 mx-4 bg-gray-200" data-id="element-3325">
                      <div className={`h-1 bg-blue-900 ${formStep >= 2 ? 'w-full' : 'w-0'} transition-all duration-300`} data-id="element-3326"></div>
                    </div>
                    <div className="flex items-center" data-id="element-3327">
                      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${formStep >= 2 ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-500'} mr-2`} data-id="element-3328">
                        2
                      </div>
                      <span className={`font-medium ${formStep >= 2 ? 'text-blue-900' : 'text-gray-500'}`} data-id="element-3329">
                        Education & Career
                      </span>
                    </div>
                    <div className="flex-1 h-1 mx-4 bg-gray-200" data-id="element-3330">
                      <div className={`h-1 bg-blue-900 ${formStep >= 3 ? 'w-full' : 'w-0'} transition-all duration-300`} data-id="element-3331"></div>
                    </div>
                    <div className="flex items-center" data-id="element-3332">
                      <div className={`flex items-center justify-center w-8 h-8 rounded-full ${formStep >= 3 ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-500'} mr-2`} data-id="element-3333">
                        3
                      </div>
                      <span className={`font-medium ${formStep >= 3 ? 'text-blue-900' : 'text-gray-500'}`} data-id="element-3334">
                        Membership
                      </span>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleSubmit} data-id="element-3335">
                  {formStep === 1 && <div className="space-y-4 animate-fadeIn" data-id="element-3336">
                      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-3337">
                        Personal Information
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3338">
                        <div data-id="element-3339">
                          <label htmlFor="firstName" className="block text-gray-700 font-medium mb-1" data-id="element-3340">
                            First Name
                          </label>
                          <input type="text" id="firstName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3341" />
                        </div>
                        <div data-id="element-3342">
                          <label htmlFor="lastName" className="block text-gray-700 font-medium mb-1" data-id="element-3343">
                            Last Name
                          </label>
                          <input type="text" id="lastName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3344" />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3345">
                        <div data-id="element-3346">
                          <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-3347">
                            Email Address
                          </label>
                          <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3348" />
                        </div>
                        <div data-id="element-3349">
                          <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-3350">
                            Phone Number
                          </label>
                          <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3351" />
                        </div>
                      </div>
                      <div data-id="element-3352">
                        <label htmlFor="address" className="block text-gray-700 font-medium mb-1" data-id="element-3353">
                          Current Address
                        </label>
                        <textarea id="address" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3354"></textarea>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3355">
                        <div data-id="element-3356">
                          <label htmlFor="city" className="block text-gray-700 font-medium mb-1" data-id="element-3357">
                            City
                          </label>
                          <input type="text" id="city" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3358" />
                        </div>
                        <div data-id="element-3359">
                          <label htmlFor="state" className="block text-gray-700 font-medium mb-1" data-id="element-3360">
                            State
                          </label>
                          <input type="text" id="state" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3361" />
                        </div>
                        <div data-id="element-3362">
                          <label htmlFor="country" className="block text-gray-700 font-medium mb-1" data-id="element-3363">
                            Country
                          </label>
                          <input type="text" id="country" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3364" />
                        </div>
                      </div>
                      <div className="flex justify-end mt-6" data-id="element-3365">
                        <Button type="button" onClick={nextStep} variant="primary" data-id="element-3366">
                          Next: Education & Career
                        </Button>
                      </div>
                    </div>}
                  {formStep === 2 && <div className="space-y-4 animate-fadeIn" data-id="element-3367">
                      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-3368">
                        Education & Career Information
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3369">
                        <div data-id="element-3370">
                          <label htmlFor="graduationYear" className="block text-gray-700 font-medium mb-1" data-id="element-3371">
                            Year of Graduation from IGS
                          </label>
                          <input type="number" id="graduationYear" min="1967" max="2023" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3372" />
                        </div>
                        <div data-id="element-3373">
                          <label htmlFor="set" className="block text-gray-700 font-medium mb-1" data-id="element-3374">
                            Set/Class
                          </label>
                          <input type="text" id="set" placeholder="e.g., 1990/1996 Set" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3375" />
                        </div>
                      </div>
                      <div data-id="element-3376">
                        <label htmlFor="education" className="block text-gray-700 font-medium mb-1" data-id="element-3377">
                          Highest Educational Qualification
                        </label>
                        <select id="education" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3378">
                          <option value="" data-id="element-3379">Select qualification</option>
                          <option value="Secondary School" data-id="element-3380">
                            Secondary School
                          </option>
                          <option value="Diploma" data-id="element-3381">Diploma/Certificate</option>
                          <option value="Bachelor" data-id="element-3382">Bachelor's Degree</option>
                          <option value="Master" data-id="element-3383">Master's Degree</option>
                          <option value="Doctorate" data-id="element-3384">Doctorate</option>
                          <option value="Other" data-id="element-3385">Other</option>
                        </select>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3386">
                        <div data-id="element-3387">
                          <label htmlFor="profession" className="block text-gray-700 font-medium mb-1" data-id="element-3388">
                            Current Profession
                          </label>
                          <input type="text" id="profession" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3389" />
                        </div>
                        <div data-id="element-3390">
                          <label htmlFor="company" className="block text-gray-700 font-medium mb-1" data-id="element-3391">
                            Company/Organization
                          </label>
                          <input type="text" id="company" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-3392" />
                        </div>
                      </div>
                      <div data-id="element-3393">
                        <label htmlFor="bio" className="block text-gray-700 font-medium mb-1" data-id="element-3394">
                          Brief Bio/Profile
                        </label>
                        <textarea id="bio" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Share a brief summary of your professional journey, achievements, and interests." data-id="element-3395"></textarea>
                      </div>
                      <div className="flex justify-between mt-6" data-id="element-3396">
                        <Button type="button" onClick={prevStep} variant="outline" data-id="element-3397">
                          Back
                        </Button>
                        <Button type="button" onClick={nextStep} variant="primary" data-id="element-3398">
                          Next: Membership Options
                        </Button>
                      </div>
                    </div>}
                  {formStep === 3 && <div className="space-y-4 animate-fadeIn" data-id="element-3399">
                      <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-3400">
                        Membership Options
                      </h3>
                      <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mb-6" data-id="element-3401">
                        <h4 className="font-bold text-blue-900 mb-2" data-id="element-3402">
                          Membership Types
                        </h4>
                        <div className="space-y-3" data-id="element-3403">
                          <div className="flex items-start" data-id="element-3404">
                            <input type="radio" id="regular" name="membershipType" value="regular" className="mt-1" defaultChecked data-id="element-3405" />
                            <label htmlFor="regular" className="ml-2" data-id="element-3406">
                              <div className="font-medium text-blue-900" data-id="element-3407">
                                Regular Membership - ₦5,000/year
                              </div>
                              <div className="text-sm text-gray-600" data-id="element-3408">
                                Basic membership with access to alumni network
                                and events.
                              </div>
                            </label>
                          </div>
                          <div className="flex items-start" data-id="element-3409">
                            <input type="radio" id="premium" name="membershipType" value="premium" className="mt-1" data-id="element-3410" />
                            <label htmlFor="premium" className="ml-2" data-id="element-3411">
                              <div className="font-medium text-blue-900" data-id="element-3412">
                                Premium Membership - ₦15,000/year
                              </div>
                              <div className="text-sm text-gray-600" data-id="element-3413">
                                Enhanced benefits including exclusive events and
                                mentoring opportunities.
                              </div>
                            </label>
                          </div>
                          <div className="flex items-start" data-id="element-3414">
                            <input type="radio" id="lifetime" name="membershipType" value="lifetime" className="mt-1" data-id="element-3415" />
                            <label htmlFor="lifetime" className="ml-2" data-id="element-3416">
                              <div className="font-medium text-blue-900" data-id="element-3417">
                                Lifetime Membership - ₦100,000
                              </div>
                              <div className="text-sm text-gray-600" data-id="element-3418">
                                One-time payment for lifetime membership with
                                all premium benefits.
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div data-id="element-3419">
                        <label className="block text-gray-700 font-medium mb-2" data-id="element-3420">
                          Areas of Interest (Select all that apply)
                        </label>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-3421">
                          <div className="flex items-center" data-id="element-3422">
                            <input type="checkbox" id="mentoring" className="mr-2" data-id="element-3423" />
                            <label htmlFor="mentoring" data-id="element-3424">
                              Mentoring Current Students
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-3425">
                            <input type="checkbox" id="fundraising" className="mr-2" data-id="element-3426" />
                            <label htmlFor="fundraising" data-id="element-3427">
                              Fundraising & Development
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-3428">
                            <input type="checkbox" id="events" className="mr-2" data-id="element-3429" />
                            <label htmlFor="events" data-id="element-3430">
                              Event Planning & Organization
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-3431">
                            <input type="checkbox" id="networking" className="mr-2" data-id="element-3432" />
                            <label htmlFor="networking" data-id="element-3433">
                              Professional Networking
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-3434">
                            <input type="checkbox" id="scholarship" className="mr-2" data-id="element-3435" />
                            <label htmlFor="scholarship" data-id="element-3436">
                              Scholarship Programs
                            </label>
                          </div>
                          <div className="flex items-center" data-id="element-3437">
                            <input type="checkbox" id="reunion" className="mr-2" data-id="element-3438" />
                            <label htmlFor="reunion" data-id="element-3439">Class Reunions</label>
                          </div>
                        </div>
                      </div>
                      <div data-id="element-3440">
                        <label htmlFor="comments" className="block text-gray-700 font-medium mb-1" data-id="element-3441">
                          Additional Comments
                        </label>
                        <textarea id="comments" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Any other information you'd like to share with us" data-id="element-3442"></textarea>
                      </div>
                      <div className="flex items-start mt-4" data-id="element-3443">
                        <input type="checkbox" id="terms" className="mt-1" required data-id="element-3444" />
                        <label htmlFor="terms" className="ml-2 text-sm text-gray-700" data-id="element-3445">
                          I agree to the{' '}
                          <a href="/terms-of-use" className="text-blue-700 hover:underline" data-id="element-3446">
                            Terms of Use
                          </a>{' '}
                          and{' '}
                          <a href="/privacy-policy" className="text-blue-700 hover:underline" data-id="element-3447">
                            Privacy Policy
                          </a>
                          . I confirm that all information provided is accurate.
                        </label>
                      </div>
                      <div className="flex justify-between mt-6" data-id="element-3448">
                        <Button type="button" onClick={prevStep} variant="outline" data-id="element-3449">
                          Back
                        </Button>
                        <Button type="submit" variant="primary" data-id="element-3450">
                          Submit Application
                        </Button>
                      </div>
                    </div>}
                </form>
              </>}
          </div>
          <div data-id="element-3451">
            <div className="bg-blue-900 text-white p-6 rounded-lg shadow-md mb-6" data-id="element-3452">
              <h3 className="text-xl font-bold mb-4" data-id="element-3453">Membership Benefits</h3>
              <ul className="space-y-3" data-id="element-3454">
                <li className="flex items-start" data-id="element-3455">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3456">
                    ✓
                  </div>
                  <p data-id="element-3457">Access to alumni networking platform</p>
                </li>
                <li className="flex items-start" data-id="element-3458">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3459">
                    ✓
                  </div>
                  <p data-id="element-3460">Invitations to alumni events and reunions</p>
                </li>
                <li className="flex items-start" data-id="element-3461">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3462">
                    ✓
                  </div>
                  <p data-id="element-3463">Regular newsletters and updates</p>
                </li>
                <li className="flex items-start" data-id="element-3464">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3465">
                    ✓
                  </div>
                  <p data-id="element-3466">Career development opportunities</p>
                </li>
                <li className="flex items-start" data-id="element-3467">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3468">
                    ✓
                  </div>
                  <p data-id="element-3469">Mentorship programs</p>
                </li>
                <li className="flex items-start" data-id="element-3470">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3471">
                    ✓
                  </div>
                  <p data-id="element-3472">Alumni directory access</p>
                </li>
                <li className="flex items-start" data-id="element-3473">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-3474">
                    ✓
                  </div>
                  <p data-id="element-3475">Opportunities to give back to IGS</p>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-3476">
              <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-3477">
                Contact Information
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-3478">
                If you have any questions about alumni membership or need
                assistance with the registration process, please contact:
              </p>
              <div className="space-y-2 text-gray-700" data-id="element-3479">
                <p data-id="element-3480">
                  <strong data-id="element-3481">Alumni Relations Office</strong>
                </p>
                <p data-id="element-3482">Email: alumni@isonyingrammarschool.edu.ng</p>
                <p data-id="element-3483">Phone: +234 (0) 803 456 7890</p>
                <p data-id="element-3484">Office Hours: Monday-Friday, 9:00 AM - 4:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AlumniJoin;